import React, { useState, useContext, useEffect } from 'react';
import './WishlistEmailModal.css';
import { Modal } from 'web-store-modules/packages/web-store-ui-library';
import { getStoreId, sendWishlistEmail, getLogoDataAsync } from '../../../../utils/StoreConfigManager';
import { AddToCartContext } from '../../add-to-cart/AddToCartContext';
import WishlistEmailCartItem from './WishlistEmailCartItem';
import { constructUrl } from '../../../../utils/UrlConstructor.js';
import {WishlistSendEmailButtonClicked, SendEmailButtonClicked} from '../../../../utils/Analytics'
import {gifting} from '../../../../utils/StaticAssetManager'
import { withTranslation } from 'react-i18next';

const closeIconStyle = { display: 'none' }
const closeIcon = 'https://cdn.obsess-vr.com/modal-close-icon-normal.png';
const emailIcon = 'https://cdn.obsess-vr.com/jared/jared-email-wishlist-gold.png';
const imageSrc = 'https://cdn.obsess-vr.com/ferragamo/Ferragamo-logo-header.png';
const activeSignupIcon = 'https://cdn.obsess-vr.com/american-girl/email-acquisition/active_signup.svg';
const inactiveSignupIcon = 'https://cdn.obsess-vr.com/american-girl/email-acquisition/inactive_signup.svg'
const ADD_TO_CART_COOKIE_ENUM = 'wishList';
const storeId = getStoreId();

const WishlistEmailModal = ({ showModal, onCLoseCallback, menuTextFontStyle, t }) => {
    const [firstName, setFirstName] = useState('');
    const [email, setEmail] = useState('');
    const [finalize, setFinalize] = useState(false);
    const [message, setMessage] = useState('');
    // const [imageSrc, setImageSrc] = useState('');
    const { cartList, pricePrefix, removeFromCart } = useContext(AddToCartContext);
    const [recipientName, setRecipientName] = useState('');
    const [recipientEmail, setRecipientEmail] = useState('');

    useEffect(() => {
        const cartArrow= document.getElementById('add-to-cart-arrow');
        const cartMenu= document.getElementById('add-to-cart-menu');
        if(!cartArrow || cartMenu){
            return;
        }
        if(showModal){
            cartArrow.classList.add('hide')
            cartMenu.classList.add('hide')
        }else{
            cartArrow.classList.remove('hide')
            cartMenu.classList.remove('hide')
        }
    }, [showModal]);

    const onClose = () => {
        setFinalize(false)
        setFirstName('')
        setEmail('')
        setMessage('')
        setRecipientEmail('')
        setRecipientName('')
        onCLoseCallback()
    }

    const setModalOpened = () => {
    }

    const getCookie = (name) => {
        const regEx = new RegExp(name + "=([^;]+)");
        const value = regEx.exec(document.cookie);
        return value ? unescape(value[1]) : null;
    }

    const handleSubmit = () => {
        if ( !recipientEmail || !recipientName) return;

        const modalWrapper = document.getElementsByClassName('position-wrapper');
        let cookies_cart_data = getCookie(ADD_TO_CART_COOKIE_ENUM);
        cookies_cart_data = cookies_cart_data.replace(/&/g, "&amp;")
        const cartListCookie = JSON.parse(cookies_cart_data);
        let emailArr = [];
        let recipientArr = [];
        emailArr.push(email)
        recipientArr.push(recipientEmail)
        emailArr = emailArr.filter((item) => item);
        if (cartListCookie && cartListCookie['id'] === storeId) {
            const cartData = cartListCookie['wishList'];
            sendWishlistEmail(storeId, cartData , firstName, emailArr,recipientName, message, imageSrc, t,recipientArr)
                .then(res => {
                    if (modalWrapper.length) {
                        modalWrapper[0].style.top = "15%";
                    }
                    setFinalize(true)
                })
                .catch(err => console.error(err));
        }

    }

    const WishlistEmailForm = () => {
        const checkMandatoryFields = recipientName && recipientEmail
        return (
            <div className="wishlist-email-form">
                <div className="email-form">
                    <div className="form-group-custom">
                        <input
                            type="text"
                            placeholder={`${t('emailPopUp3')}*`}
                            name="recipient_name"
                            autoComplete="off"
                            onChange={e => setRecipientName(e.target.value)}
                        />
                    </div>
                    <div className="form-group-custom">
                        <input
                            type="email"
                            placeholder={`${t('emailPopUp4')}*`}
                            name="recipient_email"
                            autoComplete="off"
                            onChange={e => setRecipientEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group-custom">
                        <input
                            type="text"
                            placeholder={`${t('emailPopUp1')}`}
                            name="firstName"
                            autoComplete="off"
                            onChange={e => setFirstName(e.target.value)}
                        />
                    </div>
                    <div className="form-group-custom">
                        <input
                            type="email"
                            placeholder={`${t('emailPopUp2')}`}
                            name="email"
                            autoComplete="off"
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="form-group-custom">
                        <textarea
                            type="textarea"
                            placeholder={`${t('emailPopUp5')}`}
                            name="message"
                            autoComplete="off"
                            onChange={e => setMessage(e.target.value)}
                        />
                    </div>
                </div>
                <div className="email-form-submit" onClick={handleSubmit}>
                    <button className={"send-email"} disabled={checkMandatoryFields ? false : true}>{t('emailPopUp6')}</button>
                </div>
                <div className="policy-text">{t('emailPopUp7')}</div>
            </div>
        )
    }

    if (!showModal) return false;

    return (
        <Modal
            animationType={'flyup'}
            setModalOpened={setModalOpened}
            onClose={onClose}
            closeIconStyle={closeIconStyle}
            isLoading={false}
            wrapperStyle={{ backgroundColor: 'rgb(255, 255, 255)' }}
            className={finalize ? 'email-sent' : 'email-form-open'}
        >
            <div className="wishlist-email-container">
                <div className="store-logo">
                    <img src={imageSrc} />
                </div>
                <div className="cartitem-list-part">
                    <div className="close-icon"><img src={closeIcon} onClick={() => onClose()} /></div>
                    {!finalize && WishlistEmailForm()}
                    {finalize && <div className="email-title-text">{t('emailSentNote')}</div>}
                </div>
                {/* <div className="wishlist-form-part">
                    
                </div> */}
            </div>
        </Modal>
    )
}

export default withTranslation()(WishlistEmailModal);